import OtherGreenhouseGas from './OtherGreenhouseGas';

export default OtherGreenhouseGas;
